import React from 'react';
import AdminPanelDiagnosisCodesForm from 'components/molecules/admin-panel/forms/diagnosis-codes';
import AdminPanelEmrDetailsForm from 'components/molecules/admin-panel/forms/emr-details';
import BaseGrid from 'components/atoms/base-grid';
import PriorAuthorizationForm from 'components/molecules/admin-panel/forms/prior-authorization';
import PatientSubscriptionsForm from 'components/molecules/admin-panel/forms/patient-subscriptions';
import { ModuleType } from 'infrastructure/enums';
import CareLocationTable from 'components/molecules/admin-panel/forms/care-location/table';
import classNames from 'classnames';
import Attachments from 'components/organisms/patient-attachments';
import { isCcmModule, isCombinedModule } from 'infrastructure/functions';
import { useCheckPatientModule } from 'infrastructure/hooks/patient/use-check-patient-module';

import s from './styles.module.scss';

interface IAdminTabbedFormOtherInfoProps {
  patientGuid: string;
  module: ModuleType;
  readOnly: boolean;
}

const AdminTabbedFormOtherInfo: React.FC<IAdminTabbedFormOtherInfoProps> = (
  props,
) => {
  const { patientGuid, module, readOnly } = props;
  const { isBlockCcmModule, isReadonlyCcmModule } =
    useCheckPatientModule(patientGuid);
  const readOnlyCareLocation = isCombinedModule(module)
    ? isBlockCcmModule || isReadonlyCcmModule || readOnly
    : readOnly;

  return (
    <BaseGrid rowGap={5} className={s.wrapper}>
      <div className={s['border-bottom']}>
        <BaseGrid columns={2} columnGap={20}>
          <div className={s['border-right']}>
            <AdminPanelDiagnosisCodesForm
              patientGuid={patientGuid}
              module={module}
              readOnly={readOnly}
            />
          </div>
          <AdminPanelEmrDetailsForm
            patientGuid={patientGuid}
            module={module}
            readOnly={readOnly}
          />
        </BaseGrid>
      </div>
      <div className={classNames(s['border-bottom'], s['p-b'])}>
        {!isCcmModule(module) && (
          <PriorAuthorizationForm
            patientGuid={patientGuid}
            module={module}
            readOnly={readOnly}
          />
        )}
        {(isCcmModule(module) || isCombinedModule(module)) && (
          <CareLocationTable
            patientGuid={patientGuid}
            readOnly={readOnlyCareLocation}
          />
        )}
      </div>
      <div className={classNames(s['border-bottom'], s['p-b'])}>
        <PatientSubscriptionsForm
          patientGuid={patientGuid}
          module={module}
          readOnly={readOnly}
        />
      </div>
      {module === ModuleType.ADMIN && (
        <Attachments patientGuid={patientGuid} readOnly={readOnly} />
      )}
    </BaseGrid>
  );
};

export default AdminTabbedFormOtherInfo;
